import React, { useEffect, useRef, useState } from "react";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import imageCompression from "browser-image-compression";
import { Button, Dropdown, Input, Modal, message } from "antd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { UploadOutlined } from "@ant-design/icons";
import { MdOutlineDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { BsImageFill } from "react-icons/bs";
// import ProductImagePreview from "../productImagePreview/ProductImagePreview";
// import EmbedFiles from "./EmbedFiles";

// const datas = [
//   {
//     name: "Image1",
//     type: "image/webp",
//     status: "done",
//     url:
//       "https://zeeqr2.s3.ap-south-1.amazonaws.com/33eff693de75af2ed3ca1787019f59f6a8af537326b4ba394060606d39fcab2f",
//   },
//   {
//     name: "Image2",
//     type: "image/webp",
//     status: "done",
//     url:
//       "https://zeeqr2.s3.ap-south-1.amazonaws.com/4a617809978aa4fa703ab87c1ce5d4b2247d17b42bac0556edbb25d068706309",
//   },
//   {
//     name: "Image3",
//     type: "image/webp",
//     status: "done",
//     url:
//       "https://zeeqr2.s3.ap-south-1.amazonaws.com/33eff693de75af2ed3ca1787019f59f6a8af537326b4ba394060606d39fcab2f",
//   },
//   {
//     name: "Image4",
//     type: "image/webp",
//     status: "done",
//     url:
//       "https://zeeqr2.s3.ap-south-1.amazonaws.com/4a617809978aa4fa703ab87c1ce5d4b2247d17b42bac0556edbb25d068706309",
//   },
//   {
//     name: "Image5",
//     type: "image/webp",
//     status: "done",
//     url:
//       "https://zeeqr2.s3.ap-south-1.amazonaws.com/6c450cf3e240155c15fa5dceacfe2cde1c2ba798bf0efe8a1387d6df20c79163",
//   },
// ];


const MediaLink = ({
    index,
    name,
    type,
    mediaFile,
    details,
    moveLink,
    removeLink,
    editLink,
    productID
}) => {
    const [{ isDragging }, drag] = useDrag({
        type: "SOCIAL_MEDIA_LINK", // Define the type here
        item: { index },
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging(),
        }),
    });

    const [, drop] = useDrop({
        accept: "SOCIAL_MEDIA_LINK",
        hover: (item) => {
            if (item.index !== index) {
                moveLink(item.index, index);
                item.index = index;
            }
        },
    });

    return (
        <li
            ref={(node) => drag(drop(node))}
            className={`group relative rounded-xl border border-gray-200 bg-white overflow-hidden cursor-move transition-shadow hover:shadow-md ${isDragging ? "opacity-50 shadow-none" : "opacity-100"
                }`}
        >
            <div className="relative w-full aspect-square">
                {(details?.originFileObj?.type || details?.url) && (
                    <>
                        {type.startsWith("image") ? (
                            <img
                                className="w-full h-full object-cover"
                                src={details?.originFileObj?.type ? URL.createObjectURL(details?.originFileObj) : details?.url}
                                alt="Uploaded"
                            />
                        ) : type.startsWith("embed") ? (
                            <div className="w-full h-full min-h-[140px]">
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src={details?.url}
                                    title="Embed"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="w-full h-full min-h-[140px] rounded-t-xl"
                                />
                            </div>
                        ) : (
                            <video
                                className="w-full h-full object-cover"
                                controls
                                src={details?.originFileObj?.type ? URL.createObjectURL(details?.originFileObj) : details?.url}
                            />
                        )}
                    </>
                )}

                <div className="absolute inset-0 flex flex-col justify-end">
                    {/* {type.startsWith("image") ?
            <div className="absolute top-0 left-0 right-0 bottom-0 flex gap-5 justify-center items-center bg-black bg-opacity-50 opacity-0 transition-opacity duration-300 hover:opacity-100">
              <span className="text-white text-2xl cursor-pointer" >
                <FaRegEdit />
              </span>
              <span className="text-white text-2xl cursor-pointer" >
                <MdOutlineDelete />
              </span>
            </div>
            : */}
                    {/* <div className="flex flex-col gap-2 pl-2 justify-center items-center"> */}
                    {/* <button
                onClick={() => editLink(index, name, type, mediaFile)}
                className="ml-2 px-2 py-1 bg-yellow-500 text-white rounded"
              >
                Edit
              </button>
              <button
                onClick={() => removeLink(index)}
                className="ml-2 px-2 py-1 bg-red-500 text-white rounded"
              >
                Remove
              </button> */}
                    {/* <span className="text-black text-2xl cursor-pointer" >
                <FaRegEdit />
              </span>
              <span className="text-black text-2xl cursor-pointer" >
                <MdOutlineDelete />
              </span>
            </div> */}
                    {/* } */}
                    <div className="absolute top-2 right-2 flex flex-col gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                        {!productID && (
                            <button type="button" onClick={() => editLink(index, name, type, mediaFile)} className="text-white bg-[#1955EB] p-2 rounded-lg cursor-pointer hover:bg-[#1945E0] shadow-sm" aria-label="Edit">
                                <FaRegEdit className="text-sm" />
                            </button>
                        )}
                        <button type="button" onClick={() => removeLink(index)} className="text-white bg-red-500 p-2 rounded-lg cursor-pointer hover:bg-red-600 shadow-sm" aria-label="Remove">
                            <MdOutlineDelete className="text-sm" />
                        </button>
                    </div>
                </div>
            </div>
        </li>
    );
};

const ImageVideoUploader = ({ images, setImages, productID, identifier, customImage, variant }) => {
    // const [images, setImages] = useState([]);
    const [imageType, setImageType] = useState("");
    const [imageName, setImageName] = useState("");
    const [mediaFile, setMediaFile] = useState(null);

    const [editingIndex, setEditingIndex] = useState(null);

    const fileInputRef = useRef(null);
    const [messageApi, contextHolder] = message.useMessage();

    const [dialogOpen, setDialogOpen] = useState(false);
    const [pending, setPending] = useState([]);
    const [pending1, setPending1] = useState([]);
    const [cropper, setCropper] = useState();
    const [loader, setLoader] = useState(false);
    const [change, setChange] = useState("");
    // console.log(images, "links");
    // console.log(mediaFile, "mediaFile");
    // useEffect(() => {
    //   setImages(datas);
    // }, []);

    const warning = () => {
        messageApi.open({
            type: 'warning',
            content: 'This option not supported for this field',
        });
    };

    const addSocialMediaLink = () => {
        if (imageType && imageName && mediaFile) {
            setImages([
                ...images,
                { name: imageName, type: imageType, status: 'done', originFileObj: mediaFile },
            ]);
            setImageType("");
            setImageName("");
            setMediaFile(null);
        }
    };

    const removeSocialMediaLink = (index) => {
        const updatedLinks = [...images];
        // updatedLinks.splice(index, 1);
        if (updatedLinks[index]?.existing) {
            updatedLinks.splice(index, 1);

        } else {

            updatedLinks[index].status = 'removed'
        }
        setImages(updatedLinks);
    };

    const editSocialMediaLink = (index, name, type, media) => {
        setEditingIndex(index);
        setImageName(name);
        setImageType(type);
        setMediaFile(media);
        // document.getElementById(`file-image-input`).click();
        document.getElementById(`file-image-input-${identifier}`).click();
    };

    const saveEditedLink = () => {
        console.log("edittttttttt");
        if (editingIndex !== null && imageType && imageName && mediaFile) {
            const updatedLinks = [...images];
            updatedLinks[editingIndex] = {
                name: imageName,
                type: imageType,
                status: 'done',
                originFileObj: mediaFile,
            };

            setImages(updatedLinks);
            setEditingIndex(null);
            setImageType("");
            setImageName("");
            setMediaFile(null);
        }
    };

    const moveSocialMediaLink = (fromIndex, toIndex) => {
        const updatedLinks = [...images];
        const [movedLink] = updatedLinks.splice(fromIndex, 1);
        updatedLinks.splice(toIndex, 0, movedLink);
        setImages(updatedLinks);
    };

    const getImage = (file) => {
        return new Promise((resolve, reject) => {
            const fr = new FileReader();
            fr.onload = () => {
                resolve(fr.result);
            };
            fr.addEventListener("error", (e) => {
                reject(e);
            });
            fr.readAsDataURL(file);
        });
    };

    const handleChangeImage = async (event) => {
        // console.log(event.target.files, "event.target.files");
        // setImageName(event.target.files[0].name);
        // setImageType(event.target.files[0].type);
        // setMediaFile(event.target.files[0]);
        const files = event.target.files;
        if (files) {
            setImageName(files[0].name);
            setImageType(files[0].type);

            if (files[0].type.startsWith("image")) {
                if (files.length) {
                    // console.log("number of files", files.length);
                    setPending(
                        await Promise.all(Array.from(files).map((file) => getImage(file)))
                    );
                    setPending1(files[0])
                    setDialogOpen(true);
                }
            } else if (files[0].type.startsWith("video")) {
                setMediaFile(files[0]);
                setChange(Date.now());
            }
        }
    };

    const handleCancelUploadModal = () => {
        setDialogOpen(false);
        fileInputRef.current.value = null;
    };

    function blobToBase64(blob) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    }

    const onComplete = async () => {
        setLoader(true);
        const blob = await new Promise((resolve, reject) => {
            cropper.getCroppedCanvas().toBlob(resolve);
        });
        // console.log(blob, 'kkkkk');
        const options = {
            maxSizeMB: 0.5,
            fileType: "image/webp",
            maxWidthOrHeight: 1920,
        };
        const image = await imageCompression(blob, options);
        // console.log(image, "pppp");
        setMediaFile(image);
        setChange(Date.now());
        // const base64Img = await blobToBase64(image);
        // console.log(base64Img, '77777');

        // onDataFromChild(image, base64Img);
        setLoader(false);
        const newPending = [...pending];
        newPending.shift();
        if (newPending.length === 0) {
            handleCancelUploadModal();
        }
        setPending(newPending);
    };

    const onWithoutCrop = async () => {
        // console.log(pending1, 'croppercroppercropper');
        // console.log(pending[0], 'pending[0]');
        setMediaFile(pending1);
        setChange(Date.now());
        handleCancelUploadModal();
    }

    useEffect(() => {
        if (editingIndex !== null) {
            saveEditedLink();
        } else {
            addSocialMediaLink();
        }
    }, [change]);
    // console.log(editingIndex, "editingIndex");

    const [isModelOpen, setIsModelOpen] = useState(false);
    const [embedIsModelOpen, setEmbedIsModelOpen] = useState(false);

    const handleCancelModal = () => {
        setIsModelOpen(false);
    };
    const handleGalleryModal = () => {
        setIsModelOpen(true);
    }
    const handleEmbededModal = () => {
        setEmbedIsModelOpen(true);
    }
    const handleEmbedCancelModal = () => {
        setEmbedIsModelOpen(false);
    };

    const onUploadButtonHandleClick = (identifierClick) => {
        document.getElementById(`file-image-input-${identifierClick}`).click();
    };

    const triggerFileInput = () => onUploadButtonHandleClick(identifier);

    const minPhotos = 1;
    const hasImages = images?.some((item) => item?.status === "done" || (item?.url && item?.status !== "removed"));
    const photoCount = hasImages
        ? Math.max(minPhotos, images?.filter((i) => i?.status === "done" || (i?.url && i?.status !== "removed")).length)
        : minPhotos;


    const items = [
        {
            key: '1',
            label: (
                // <div className="cursor-pointer" onClick={() => fileInputRef.current.click()} ><UploadOutlined /> Upload from files</div>
                <div className="cursor-pointer" onClick={() => onUploadButtonHandleClick(identifier)} ><UploadOutlined /> Upload from files</div>
                // <Button icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()} >Click to Upload</Button>
            ),
        },
        {
            key: '2',
            label: (
                <div onClick={handleGalleryModal} ><UploadOutlined /> Upload from Existing</div>
            ),
        },
        {
            key: '3',
            label: (
                <div onClick={customImage ? warning : handleEmbededModal} ><UploadOutlined /> Upload Embed video</div>
            ),
        },

    ];

    const handleDataFromChild = (data) => {
        // Do something with the data in the parent component
        console.log('Data received from child:', data);
        // setDataFromChild(data);
        data.existing = true
        images.push(data)

        handleCancelModal()
    };

    const handleEmbedDataFromChild = (data) => {
        // Do something with the data in the parent component
        console.log('Data received from child:', data);

        const details = {
            name: data.from,
            type: "embed/" + data.from,
            url: data.url,
            status: "done",
        }
        // setDataFromChild(data);
        // data.existing = true
        images.push(details)

        handleEmbedCancelModal()
    };

    // console.log(images,'images');
    const statusExistsDone = (status) => images?.some(item => item?.status === status);
    const statusExistsRemove = (status) => images?.some(item => item?.status !== status);

    return (
        <DndProvider backend={HTML5Backend}>
            <div className="w-full my-4">

                <input
                    type="file"
                    id={`file-image-input-${identifier}`}
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={handleChangeImage}
                    accept="image/*"
                />

                {variant === "createBid" && (
                    <div className="mb-6 text-left">
                        <h2 className="text-lg font-semibold mb-1 text-gray-900 text-left">Photos</h2>
                        <p className="text-sm text-gray-500 mb-4 text-left">
                            Add at least {photoCount} photo{photoCount !== 1 ? "s" : ""}. Drag to reorder.
                        </p>

                        <div className="flex gap-3 overflow-x-auto pb-2">
                            {/* Uploaded Images */}
                            {images?.map((img, index) => (
                                img?.status === "removed" ? null : (
                                    <div
                                        key={index}
                                        className="relative w-28 h-28 rounded-xl overflow-hidden border shadow-sm shrink-0 transition-transform duration-300"
                                    >
                                        <img
                                            src={
                                                img?.originFileObj?.type
                                                    ? URL.createObjectURL(img.originFileObj)
                                                    : img?.url
                                            }
                                            alt=""
                                            className="w-full h-full object-cover"
                                        />

                                        <button
                                            type="button"
                                            onClick={() => removeSocialMediaLink(index)}
                                            className="absolute top-1 right-1 bg-black/60 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-black"
                                            aria-label="Remove image"
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )
                            ))}

                            {/* + Upload tile */}
                            <button
                                type="button"
                                onClick={triggerFileInput}
                                className="w-28 h-28 shrink-0 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center hover:border-blue-500 transition cursor-pointer bg-white"
                            >
                                <span className="text-2xl leading-none mb-1">+</span>
                                <span className="text-sm text-gray-600">Upload</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* Form to add new social media link */}
                {variant !== "createBid" && (
                <div className="mb-4 flex items-center">
                    {/* <div
            className="cursor-pointer"
            onClick={() => fileInputRef.current.click()}
          >
            Upload from files
          </div> */}
                    {customImage && (statusExistsDone('done') || (images[0]?.url && statusExistsRemove('removed'))) ?
                        "" :
                        <>
                            {productID ?
                                <Dropdown
                                    menu={{
                                        items,
                                    }}
                                    placement="top"
                                    arrow
                                >
                                    <Button icon={<UploadOutlined />}  >Click to Upload</Button>

                                </Dropdown>
                                :
                                <Button icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()} >Click to Upload</Button>
                            }
                        </>
                    }
                    {/* {productID ?
            <Dropdown
              menu={{
                items,
              }}
              placement="top"
              arrow
            >
              <Button icon={<UploadOutlined />}  >Click to Upload</Button>

            </Dropdown>
            :
            <Button icon={<UploadOutlined />} onClick={() => fileInputRef.current.click()} >Click to Upload</Button>
          } */}


                    {/* <button
            onClick={editingIndex !== null ? saveEditedLink : addSocialMediaLink}
            className={`ml-4 px-4 py-2 bg-${
              editingIndex !== null ? "yellow" : "blue"
            }-500 text-white rounded`}
          >
            {editingIndex !== null ? "Save" : "Add Link"}
          </button> */}
                </div>
                )}

                {/* Display added images in a grid (default layout only) */}
                {variant !== "createBid" && (
                    <ul className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 list-none p-0 m-0">
                        {images?.map((link, index) => (
                            link?.status === 'done' || (link?.url && link?.status !== 'removed') ? (
                                <MediaLink
                                    key={index}
                                    index={index}
                                    name={link.name}
                                    type={link.type}
                                    mediaFile={link.media}
                                    details={link}
                                    moveLink={moveSocialMediaLink}
                                    removeLink={removeSocialMediaLink}
                                    editLink={editSocialMediaLink}
                                    productID={productID}
                                />
                            ) : null
                        ))}
                    </ul>
                )}


                <Modal
                    open={dialogOpen}
                    onCancel={handleCancelUploadModal}
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={false}
                    footer={false}
                >
                    <div className="bg-white ">
                        <h1 className="mb-4 font-semibold text-base capitalize">
                            Crop Image
                        </h1>

                        <Cropper
                            style={{ height: 400, width: "100%" }}
                            src={pending[0]}
                            onInitialized={(instance) => {
                                setCropper(instance);
                            }}
                        />
                    </div>
                    <div className="flex justify-end mt-4">
                        <div className="flex gap-2">
                            <Button onClick={handleCancelUploadModal}>Cancel</Button>
                            <Button
                                // loading={loader}
                                onClick={onWithoutCrop}
                                type="none"
                                className="bg-gray-500 hover:bg-gray-400 hover:text-white text-white px-4 py-1 rounded"
                            >
                                Without Crop & Save
                            </Button>
                            <Button
                                loading={loader}
                                onClick={onComplete}
                                type="none"
                                className="bg-blue-500 hover:bg-blue-400 hover:text-white text-white px-4 py-2 rounded"
                            >
                                Crop & Save
                            </Button>
                        </div>
                    </div>
                </Modal>

                {/* <Modal open={isModelOpen} onCancel={handleCancelModal} maskClosable={false} destroyOnClose={false} footer={false} >
                    <h1>select your Image</h1>
                    <div className="h-[400px] overflow-auto scrollbar-hide" >
                        <ProductImagePreview uploadPage={true} onDataFromChild={handleDataFromChild} productID={productID} />
                    </div>
                </Modal> */}

                {/* <Modal open={embedIsModelOpen} onCancel={handleEmbedCancelModal} maskClosable={false} destroyOnClose={false} footer={false} >
                    <h1>Give the Embed link for iframe</h1>
                    <div className="h-[300px] overflow-auto scrollbar-hide" >

                        <EmbedFiles onDataFromChild={handleEmbedDataFromChild} />
                    </div>
                </Modal> */}
                {contextHolder}
            </div>
        </DndProvider>
    );
};

export default ImageVideoUploader;